module.exports = __webpack_public_path__ + "static/media/testfile_selectAll.730cc607.zip";